import { Link, useParams } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { MdxBody } from "@/components/MdxBody";
import { CtaBand } from "@/components/CtaBand";
import { NetworkAnalysisGraph } from "@/features/network-analysis/NetworkAnalysisGraph";
import { repos } from "@/features/work/catalog";
import { bySlug, work } from "@/lib/content/load";
import { headingText } from "@/lib/heading";
import { NotFoundPage } from "./NotFoundPage";

export function WorkCasePage() {
  const { slug = "" } = useParams();
  const record = bySlug(work, slug);
  if (!record) return <NotFoundPage />;
  const { meta, Component } = record;

  return (
    <>
      <Seo
        title={meta.title}
        description={meta.seoDescription}
        path={meta.canonicalPath}
      />
      <article className="wrap section" style={{ paddingTop: "4.5rem" }}>
        <p className="eyebrow">Projects</p>
        <h1>{headingText(meta.title)}</h1>
        <p className="lede">{meta.summary}</p>
        <MdxBody Component={Component} />
        {slug === "network-analysis" ? (
          <section className="section">
            <h2>Synthetic offer graph</h2>
            <NetworkAnalysisGraph />
          </section>
        ) : null}
        {slug === "open-source" ? (
          <section className="section">
            <h2>Repositories</h2>
            <div className="grid-2">
              {repos.map((repo) => (
                <article className="card" key={repo.name}>
                  <p className="badge">{repo.group}</p>
                  <h3>
                    <a href={repo.url}>{repo.name}</a>
                  </h3>
                  <p>{repo.why}</p>
                  <p className="meta">{repo.tech}</p>
                </article>
              ))}
            </div>
          </section>
        ) : null}
        {slug === "ecosystem-ai" ? (
          <section className="section">
            <h2>Four systems</h2>
            <div className="arch-flow">
              <article className="card">
                <h3>Workbench</h3>
                <p>Configure projects, data, models, and deployment.</p>
              </article>
              <article className="card">
                <h3>Prediction server</h3>
                <p>Projects, workers, and the model gateway.</p>
              </article>
              <article className="card">
                <h3>Client Pulse Responder</h3>
                <p>Load the campaign, score through plugins, and write the response so the next score can learn.</p>
              </article>
              <article className="card">
                <h3>Data agents</h3>
                <p>Explain live campaign and runtime data.</p>
              </article>
            </div>
          </section>
        ) : null}
        {slug === "ecosystemcode" ? (
          <section className="section">
            <h2>Generation loop</h2>
            <div className="arch-flow">
              <article className="card">
                <h3>Words</h3>
                <p>Epics, stories, domain language.</p>
              </article>
              <article className="card">
                <h3>UML</h3>
                <p>Six diagram types, visually edited.</p>
              </article>
              <article className="card">
                <h3>Ontology</h3>
                <p>OWL/RDF/SHACL. Roles become authorization.</p>
              </article>
              <article className="card">
                <h3>Baseline</h3>
                <p>Deterministic UI, API, data, Docker, MCP.</p>
              </article>
            </div>
          </section>
        ) : null}
        <p>
          <Link to="/work">All projects</Link>
        </p>
      </article>
      <CtaBand />
    </>
  );
}
